import React, { Component } from 'react'
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import { AC_ADD_GROUP, AC_DELETE_GROUP, AC_HANDLE_GROUP_CHANGE, AC_LIST_GROUP, AC_RESET_GROUP, AC_UPDATE_GROUP, AC_VIEW_GROUP, } from '../../actions/groupAction';
import { AC_LIST_HOTEL } from '../../actions/hotelAction';
import { AC_LIST_CATEGORY } from '../../actions/categoryAction';
import ImportedURL from '../../common/api';
import { Error, Success } from '../../common/swal';
import { AC_LIST_COUNTRY } from '../../actions/countryAction';
import Select from 'react-select';
import jsPDF from 'jspdf';
import { AC_LOGIN_HISTORY } from '../../actions/accountAction';
import moment from 'moment';
import Spinner from 'react-bootstrap/Spinner';
import { Capitalize, imageCellRendererList, onErrorImage } from '../../common/validate';
import { Link } from 'react-router-dom';

const initialState = {
    modalType: "Add",
    columnApi: '',
    gridApi: '',
    columnDefs: [
        { headerName: '#', valueGetter: "node.rowIndex+1", width: 50, sortable: false, filter: false, cellStyle: { 'text-align': 'center' }, hide: 'true' },
        {
            headerName: 'Logo', field: 'logo', sortable: false, filter: false, "resizable": false, width: 100, cellStyle: { 'text-align': 'center' },
            cellRenderer: imageCellRendererList,
        },
        { headerName: 'Hotel', field: 'hotelName', width: 100, floatingFilter: true },
        { headerName: 'Name', field: 'user', width: 100, cellStyle: { 'text-align': 'left' }, floatingFilter: true },
        { headerName: 'Users Category', field: 'category', width: 100, cellStyle: { 'text-align': 'left' }, floatingFilter: true },
        { headerName: 'IP Address', field: 'ip', width: 100, cellStyle: { 'text-align': 'left' }, floatingFilter: true },
        {
            headerName: 'Login Device', field: 'device', width: 100, cellStyle: { 'text-align': 'left' }, floatingFilter: true,
            valueGetter: function (params) {
                if (params.data.device) {
                    return Capitalize(params.data.device);
                }
            }
        },
        {
            headerName: 'Login Country', field: 'country', width: 100, cellStyle: { 'text-align': 'left' },
            cellRenderer: function (params) {
                if (params.data.country) {
                    let flag = `<div class=''><i class="country_ctr alignment-flag flag flag-` + params.data.countrycode + `"></i><span class="pl-2">` + params.data.country + `</span></div>`;
                    return flag
                }
            }
        },
        {
            headerName: 'Last Login', width: 150, field: 'time', cellStyle: { 'text-align': 'left' },
            cellRenderer: function (params) {
                if (params.data.time) {
                    return moment(params.data.time).tz(params.data.tzone).format("MM/DD/YYYY ddd hh:mm A");
                }
            }
        },

    ],
    defaultColumDef: {
        "width": 200,
        "filter": true,
        "sortable": true,
        "resizable": true,
    },
    nameError: false,
    ccError: false,
    emailError: false,
    emailValidError: false,
    phonenumberError: false,
    phonenumberValidError: false,
    id: '',
    cc: '+1',
    defaultCC: '',
    groupoption: '',
    groupName: '',
    searchhotel: '',
    searchhoteloption: '',
    hotelName: '',
}
class ListLoginHistory extends Component {
    constructor(props) {
        super(props);
        this.state = initialState
    }

    changeModal = (e) => {
        this.props.ResetGroup();
        this.setState({ modalType: e.target.id });
    }

    onRowClicked = event => {
        const { AccountState } = this.props;
        const languageData = AccountState.account.SelectedlanguageData
        const rowValue = event.event.target;
        const value = rowValue.getAttribute('data-action-type');
        if (value === 'Edit') {
            this.setState({ email: event.data.email, ccError: false, modalType: "Edit", id: event.data._id, nameError: false, phonenumberError: false, });
            this.props.ViewGroup(event.data);
        }

        if (value === 'Delete') {
            Swal.fire({
                title: 'Delete Group?',
                icon: 'warning',
                showCancelButton: true,
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.props.DeleteGroup(event.data._id)
                }
            })
        }
        if (value === 'Status') {
            Swal.fire({
                title: 'Are you sure you want to change the status?',
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: 'Ok',
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.post(ImportedURL.API.statusChange, { id: event.data._id, status: !event.data.status, model: 'groups' })
                        .then((data) => {
                            this.props.ListGroup();
                            Success((languageData && languageData.STATUS ? languageData.STATUS : ' Status') + (languageData && languageData.UPDATED_SUCCESSFULLY ? languageData.UPDATED_SUCCESSFULLY : "updated successfully"))
                        }).catch(({ response }) => {
                            if (response.status == 500) {
                                Error(response.status + (languageData && languageData.INTERNAL_SERVER_ERROR ? languageData.INTERNAL_SERVER_ERROR : ' Internal Server Error'))
                            } else if (response.status == 502) {
                                Error(response.status + (languageData && languageData.BAD_GATEWAY ? languageData.BAD_GATEWAY : ' Bad Gateway'))
                            } else if (response.status == 400) {
                                Error(languageData && languageData.BAD_REQUEST ? languageData.BAD_REQUEST : 'Bad request')
                            } else {
                                Error(response.statusMessage)
                            }
                        });
                }
            })
        }
    }

    onChange = e => {
        const { name, value } = e.target;
        const Error = name + "Error";
        this.setState({ [Error]: false });
        this.props.HandleInputChange(name, value);
        if (this.state.defaultCC) {
            this.props.HandleInputChange('cc', this.state.defaultCC);
        }
    }
    handleChange = e => {
        const { name, value } = e;
        const Error = name + "Error";
        this.setState({ [Error]: false });
        this.props.HandleInputChange(name, value);
    }
    handlePhoneCode = e => {
        const { name, value } = e;
        const Error = name + "Error";
        this.setState({ [Error]: false, defaultCC: '' });
        this.props.HandleInputChange(name, value);
    }

    componentDidMount() {
        this.props.LoginHistory();
        this.props.ListGroup();
        const { AccountState } = this.props;
        this.setState({ hotelName: AccountState.account.hotelName })
    }
    onGridReady = (params) => {
        this.gridColumnApi = params.columnApi;
        this.gridApi = params.api;
        this.gridApi.sizeColumnsToFit();
    }
    setGroup = e => {
        const { name, value, label } = e;
        this.props.LoginHistory({ group: value });
        this.setState({ [name + 'option']: e, groupName: label })
    }
    exportToCSV = () => {
        const account = this.props.AccountState.account;
        this.gridApi.exportDataAsCsv({
            columnKeys: ['hotel', 'user', 'category', 'ip', "device", 'country', 'time'],
            fileName: "login-history" + "_" + (account.currentTime).replace(/ /g, '_') + ".csv",
            processCellCallback: function (params) {
                return params.value;
            }
        })
    }
    searchHotel = e => {
        const { name, value, label } = e;
        this.props.LoginHistory({ hotel: value });
        this.setState({ searchhoteloption: e, searchhotel: value, hotelName: label })
    }
    exportPDF = () => {
        const account = this.props.AccountState.account;
        const { AccountState } = this.props;
        const exportData = AccountState.loginHistory;

        const unit = "pt";
        const size = "A4";
        const orientation = "landscape";
        const marginLeft = 15;
        var img = new Image();
        img.src = '../../assets/images/logo.png';
        const doc = new jsPDF(orientation, unit, size);
        doc.setFontSize(15);
        const title = (this.state.hotelName) ? (this.state.hotelName != "All" ? this.state.hotelName + " - Login History" : "Login History") : "Login History";
        if (this.state.hotelName) {
            var headers = [['#', "Name", "Users Category", "IP Address", "Login Device", "Country", "Last Login"]];
            var data = exportData.map((elt, i) => {
                return (
                    [
                        i + 1,
                        elt.user,
                        elt.category,
                        elt.ip,
                        elt.device,
                        elt.country,
                        elt.time,
                    ]);
            })
        } else {
            var headers = [['#', "Hotel", "Name", "Users Category", "IP Address", "Login Device", "Country", "Last Login"]];
            var data = exportData.map((elt, i) => {
                return (
                    [
                        i + 1,
                        elt.hotel,
                        elt.user,
                        elt.category,
                        elt.ip,
                        elt.device,
                        elt.country,
                        elt.time,
                    ]);
            })
        }


        let content = {
            startY: 70,
            head: headers,
            headStyles: { fillColor: [215, 234, 255], textColor: [28, 48, 120], },
            body: data,
            styles: {
                minCellHeight: 30,
                valign: 'middle',
                lineWidth: 0.5,
            },
            margin: {
                left: 10,
                right: 10,
                bottom: 70,
            },
            autoPaging: "text",
        };
        doc.addImage(img, 'png', 780, 6, 50, 50);
        doc.setTextColor(28, 48, 120);
        doc.text(title, marginLeft, 40);
        doc.setTextColor(28, 48, 120);
        // doc.text('MyHotel AI', 710, 40)
        doc.autoTable(content);
        var totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            if (this.state.hotelName) {
                doc.setFontSize(11);
                doc.setTextColor(110);
                doc.text(account.hotelNameExport, 20, 545);
                doc.setFontSize(11);
                doc.setTextColor(110);
                doc.text(account.hoteladdressExport, 20, 560);
            }
            doc.setPage(i);
            doc.setFontSize(11);
            doc.setTextColor(110);
            doc.text('Page ' + i + ' of ' + totalPages, doc.internal.pageSize.getWidth() - 100, doc.internal.pageSize.getHeight() - 20);
            doc.setFontSize(11);
            const fullText = 'This is an auto-generated report from MyHotel AI (www.myhotelai.com)';
            const coloredText = '(www.myhotelai.com)';
            const textColor = [28, 48, 120]; // Specify your desired text color as an RGB array

            const textXPosition = 20;
            const textYPosition = 575;

            // Calculate the width of the full text before the colored text
            const fullTextWidth = doc.getTextWidth(fullText);
            const coloredTextWidth = doc.getTextWidth(coloredText);
            const leadingText = fullText.slice(0, fullText.indexOf(coloredText));

            // Render the leading text with default color
            doc.setTextColor(110); // Set default text color
            doc.text(leadingText, textXPosition, textYPosition);

            // Render the colored text with the specified color
            doc.setTextColor(textColor[0], textColor[1], textColor[2]);
            doc.text(coloredText, textXPosition + fullTextWidth - coloredTextWidth, textYPosition);
        }
        doc.save("login-history" + "_" + (this.state.hotelName && (this.state.hotelName).replace(/ /g, '_')) + (account.currentTime).replace(/ /g, '_') + ".pdf")
    }

    render() {
        const { AccountState, GroupState, HotelState } = this.props;
        const listHotelData = HotelState.listhotels;
        const account = AccountState.account;
        const rowData = AccountState.loginHistory;
        const spinner = AccountState.spinner;
        const languageData = AccountState.account.SelectedlanguageData
        const limitOptions = [
            { value: '25', label: '25' },
            { value: '50', label: '50' },
            { value: '100', label: '100' }
        ]

        const listGroup = GroupState.listgroups;
        const groupOption = [{ label: 'All', value: '', name: 'group' }];
        listGroup && listGroup.filter(filterItem => filterItem.status === true).map(item => {
            groupOption.push({ label: item.name, value: item._id, name: 'group' });
        })

        var hotelOptionSearch = [];
        if (listHotelData.length > 1) {
            hotelOptionSearch.push({ label: 'All', value: '', name: 'searchhotel' })
        }
        if (listHotelData.length > 0) {
            listHotelData.filter(filterItem => filterItem.status === true).map(item => {
                hotelOptionSearch.push({ label: `${item.name} ${item.city} ${item.state}`, value: item._id, logo: item.logo, name: 'searchhotel' });
            })
        }
        var tzone = 'America/chicago'
        if (account != undefined && account && account.tzone != undefined && account.tzone) {
            tzone = account.tzone
        }
        rowData.forEach(object => {
            object.tzone = tzone;
        });


        return (
            <>
                <div className="breadcrump">
                    <p> <Link to="/"><h6>{languageData && languageData.DASHBOARD ? languageData.DASHBOARD : "Dashboard"}</h6></Link>  <span><i className="fa fa-angle-right" aria-hidden="true"></i> </span>  <Link to="/list-loginhistory"><h6 className="highlights_breadcrump">Login History</h6></Link></p>
                </div>
                <div className="section-body pt-3 user_sec">
                    <div className="container-fluid">
                        <div className="tab-content">
                            <div className="tab-pane fade show active" id="Departments-list" role="tabpanel">
                                <div className="card">
                                    <div className="card-header tit_res">
                                        <div className='d-flex'>
                                            <div className='rounded_icon'><i className="fa fa-sign-in mr-2 "></i></div>
                                            <div className='d-flex align-items-center'>
                                                <h3 className="card-title"> Login History List</h3>
                                            </div>
                                        </div>

                                        <div className="card-options ">
                                            {rowData && rowData.length > 0 ? <>
                                                <a className="btn btn-primary btn-sm nav-link dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><i className="fa fa-download mr-2" aria-hidden="true"></i>Export</a>
                                                <div className="dropdown-menu">
                                                    <a className="dropdown-item" type='button' onClick={this.exportToCSV}><i className="dropdown-icon fa fa-file-excel-o"></i> Excel</a>
                                                    <a className="dropdown-item" type='button' onClick={this.exportPDF}><i className="dropdown-icon fa fa-file-pdf-o"></i> PDF</a>
                                                </div>
                                            </> : []}
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-lg-2 col-md-2 col-sm-2 col-xl-3">
                                                <label className="form-label">{languageData && languageData.LIMIT ? languageData.LIMIT : "Limit"}</label>
                                                <div className="form-group">
                                                    <Select
                                                        options={limitOptions}
                                                        defaultValue={limitOptions[0]}
                                                        className='limit_size'
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-md-4 col-sm-6 col-xl-4">
                                                <label className="form-label">{languageData && languageData.GROUP ? languageData.GROUP : "Group"}</label>
                                                <div className="form-group">
                                                    <Select
                                                        value={this.state.groupoption ? { label: this.state.groupoption.label } : ''}
                                                        onChange={this.setGroup}
                                                        options={groupOption}
                                                    />
                                                </div>
                                            </div>
                                            {
                                                account?.allhotels == undefined &&
                                                <div className="col-lg-2 col-md-4 col-sm-6 col-xl-5">
                                                    <label className="form-label">{languageData && languageData.HOTEL ? languageData.HOTEL : "Hotel"}</label>
                                                    <div className="form-group" style={{ marginBottom: '10px' }}>
                                                        <Select
                                                            value={this.state.searchhoteloption}
                                                            onChange={this.searchHotel}
                                                            options={hotelOptionSearch}
                                                            formatOptionLabel={(e) => (
                                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                    {e.label != 'All' && <img className='all_search_image_size contain_image' src={ImportedURL.FILEURL + e.logo} onError={onErrorImage} />}
                                                                    <div style={e.label != 'All' ? { paddingLeft: '10px' } : {}}><span className='all_search_text_size' >{e.label}</span></div>
                                                                </div>
                                                            )}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        <div className="table-responsive">
                                            <div className="ag-theme-alpine">
                                                <AgGridReact
                                                    rowHeight={82}
                                                    paginationPageSize={25}
                                                    pagination={true}
                                                    onRowClicked={this.onRowClicked}
                                                    domLayout={"autoHeight"}
                                                    defaultColDef={this.state.defaultColumDef}
                                                    rowData={rowData}
                                                    columnDefs={this.state.columnDefs}
                                                    rowDragManaged={true}
                                                    animateRows={true}
                                                    onGridReady={this.onGridReady}
                                                    overlayNoRowsTemplate={"No rows to display"}
                                                >
                                                </AgGridReact>
                                            </div>
                                            <div id="overlay" style={{ display: spinner ? 'block' : 'none' }}></div>
                                            {spinner ?
                                                <div className='common_loader_ag_grid'>
                                                    <img className='loader_img_style_common_ag_grid' src='../../assets/images/load.png' />
                                                    <Spinner className='spinner_load_common_ag_grid' animation="border" variant="info" >
                                                    </Spinner>
                                                </div>
                                                : ''
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
const mapStateToProps = state => ({
    fixNavbar: state.settings.isFixNavbar,
    GroupState: state.group,
    CountryState: state.country,
    AccountState: state.account,
    HotelState: state.hotel,
})

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ LoginHistory: AC_LOGIN_HISTORY, ListCountry: AC_LIST_COUNTRY, HandleInputChange: AC_HANDLE_GROUP_CHANGE, ListCategory: AC_LIST_CATEGORY, ListHotel: AC_LIST_HOTEL, AddGroup: AC_ADD_GROUP, ListGroup: AC_LIST_GROUP, ViewGroup: AC_VIEW_GROUP, ResetGroup: AC_RESET_GROUP, UpdateGroup: AC_UPDATE_GROUP, DeleteGroup: AC_DELETE_GROUP, ListGroup: AC_LIST_GROUP, ListHotel: AC_LIST_HOTEL }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ListLoginHistory);